@if (showExitConfirmation()) {
  <sb-voice-message-creator-exit-confirm [duration]="duration()" (confirmExit)="close('exit-button')" />
} @else {
  @let permissionState = voiceMessageRecorderStore.permissionState();
  @if (permissionState === 'granted' || permissionState === 'prompt') {
    <sb-voice-message-recorder />
  }

  @if (permissionState === 'denied') {
    <sb-voice-message-creator-mic-access-required (exit)="close()" />
  }
}
